<template>
    <transition name="fade" @after-leave="handleAfterLeave">
      <div
        v-if="visible"
        :class="['toast', type]"
        :style="`z-index:${zIndex}`"
      >
        {{ message }}
      </div>
    </transition>
  </template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      zIndex: 800,
      message: '',
      type: 'success', // 默认类型
    };
  },
  methods: {
    show(opts = {}) {
      this.message = opts.message;
      this.type = opts.type || 'success';
      const duration = opts.duration || 2000;
      this.visible = true;
      const t = setTimeout(() => {
        clearTimeout(t);
        this.visible = false;
      }, duration);
    },
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  bottom: 200px;
  left: 50%;
  max-width: 320px;

  transform: translateX(-50%);
  padding-top: 10px;
  padding-right: 16px;
  padding-bottom: 10px;
  padding-left: 16px;

  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: @fontSmall;
  color: #fff;
  text-align: center;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;

  &.success {
    padding-left: 48px;
    &::before {
      content: '';
      .iconMixin({
        background-image: url('~@/assets/images/icon/success.png');
      });
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
    }

  }
  &.error {
    padding-left: 48px;
    &::before {
      content: '';
      .iconMixin({
        background-image: url('~@/assets/images/icon/fail.png');
      });
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
    }

  }
}

</style>
